import { createFileRoute } from '@tanstack/react-router'
import MakePaymentScreen from './-components/screen'
import { pharmacyClient } from '@/connect'
import {z} from 'zod'
import { Loading } from '@/layouts/loading';

const Params = z.object({
  page: z.number().default(1),
  pageSize: z.number().default(10),
});

type Params = z.infer<typeof Params>;
export const Route = createFileRoute('/(pharma)/_layout/suppliers/$supplierId/supplier-credit-notes/')({
  component: MakePaymentScreen,
  validateSearch: Params,
  loaderDeps: ({search: {page, pageSize}}) => ({page, pageSize}),
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
  loader: async ({params, deps}) => {
    const supplierInfo = await pharmacyClient.getSupplier({
      id: params.supplierId,
    })

    const creditNotes = await pharmacyClient.listCreditNotes({
      page: deps.page,
      pageSize: deps.pageSize,
      supplierId: params.supplierId,
      includeFullyUsed: true
    })

    return {
      supplier: supplierInfo,
      creditNotes: creditNotes,
    }
  }
})